function foo() { console.log('foo') }
function bar() { console.log('bar') }
function baz() { console.log('baz') }
function header() { 
    return 'healper-data-returm'
}

export default {foo, bar, baz, header}